import React from 'react';

import { Label as AtlaskitLabel } from '@atlaskit/form';

import { LabelStyled, RequiredIndicatorStyled } from './Label.styled';

type Props = {
  text: string;
  isRequired?: boolean;
};
export default function Label({ text, isRequired }: Props): JSX.Element {
  return (
    <LabelStyled>
      <AtlaskitLabel htmlFor={text}>{text}</AtlaskitLabel>
      {isRequired && <RequiredIndicatorStyled>*</RequiredIndicatorStyled>}
    </LabelStyled>
  );
}
